module.exports = __webpack_public_path__ + "img/ico_barley_03.4af5b809.svg";